/**
 * When the pre-check playground's recorder ends its recording (lms-backend
 * precheck/recording.ts; ai-tutor agents/precheck_playground.py).
 *
 * The agent addresses a solo room's data to everyone, the recorder included:
 * `precheck_result` is the session's outcome and `lesson_ended` its close.
 * Either ends the recording a moment later, so the tutor's last words are in.
 */
export const END_TYPES = new Set(['precheck_result', 'lesson_ended']);

/** After the result: room for the last words before the file is closed. */
export const TAIL_MS = 1500;
/** No room within this long: nothing will be heard, so stop. */
export const JOIN_GIVE_UP_MS = 90 * 1000;
/** A session's wall clock is 15 minutes; past this the recording ends whatever happened. */
export const HARD_CAP_MS = 20 * 60 * 1000;

/** The message type of a data packet, or '' when it is not one of the agent's JSON messages. */
export const messageType = (payload: Uint8Array): string => {
  try {
    const msg = JSON.parse(new TextDecoder().decode(payload));
    return msg && typeof msg.type === 'string' ? msg.type : '';
  } catch {
    return '';
  }
};

export const endsRecording = (payload: Uint8Array) => END_TYPES.has(messageType(payload));
